import { GamepadDownIcon } from './GamepadDownIcon';

/**
 * author: GreenTurtwig
 * id E007AB79-ED6E-4746-9D55-A35F6BD2C93C
 * name gamepad-down
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-down.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerDownIcon = GamepadDownIcon;
export default ControllerDownIcon